import React from 'react';
import { Platform, StyleSheet } from 'react-native';
import { SafeAreaView, type SafeAreaViewProps } from 'react-native-safe-area-context';

import { ScrollViewWithHeaderTitle, useResponsive } from '@sg/garnish';

import { AvailableCredit, LoadingAnimation, ModalNavbarBackButton } from '../../components';
import { useCustomerCredit, useStipendCredits } from '../../hooks';
import { useNavigateBack } from '../../navigation';

export const CreditDetailsScreen = () => {
  const { currentBreakpoint } = useResponsive();
  const { availableCredit, credits, isLoadingCredits } = useCustomerCredit();
  const { filteredCredits, totalCreditAmount } = useStipendCredits({
    credits,
    availableCredit,
  });

  const navigateBack = useNavigateBack();

  const safeAreaEdges = currentBreakpoint.isXS ? ANDROID_TOP_SAFE_AREA_EDGES : [];

  React.useLayoutEffect(() => {
    if (currentBreakpoint.isXS) return;
    navigateBack();
  }, [navigateBack, currentBreakpoint.isXS]);

  return (
    <SafeAreaView edges={safeAreaEdges} style={styles.container}>
      {isLoadingCredits ? (
        <LoadingAnimation />
      ) : (
        <ScrollViewWithHeaderTitle testID="account.credit.root.container">
          <AvailableCredit
            creditAmount={totalCreditAmount}
            // @ts-expect-error TS(2322): Type 'readonly { readonly __typename?: "Credit" | ... Remove this comment to see the full error message
            creditDetails={filteredCredits}
          />
        </ScrollViewWithHeaderTitle>
      )}

      <ModalNavbarBackButton />
    </SafeAreaView>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const ANDROID_TOP_SAFE_AREA_EDGES: SafeAreaViewProps['edges'] = Platform.select({
  android: ['top'],
  default: [],
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
